import { getCookies } from "./Utility";
import axios from "./axios";

export const createPolicy = async (payload: any) => {
  try {
    const tenantId = getCookies("tenant-id");
    const response = await axios.post(`/tenants/${tenantId}/privacy-policies?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,
      payload,
    );
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const updatePolicy = async ({ id, ...payload }: any,) => {
  try {
    const tenantId = getCookies("tenant-id");
    const response = await axios.put(`/tenants/${tenantId}/privacy-policies/${id}?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,
      payload,
    );
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const downloadFile = async (id: number) => {
  try {
    const tenant_id = getCookies("tenant-id");
    const response = await axios.get(`tenants/${tenant_id}/privacy-policies/${id}/download?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,{
      responseType: "blob"
    });
    return response.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const removePolicy = async (policyId: number) => {
  try {
    const tenantId = getCookies("tenant-id");
    const response = await axios.delete(`/tenants/${tenantId}/privacy-policies/${policyId}?project_id=${localStorage.getItem('DP_PROJECT_ID')}`);
    return response.data.data;
  } catch (e) {
    console.log("ERROR", e);
  }
};
